import "./BiomarkerBasicDetailsEditComponent.scss";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik} from "formik";
import FormikInputComponent from "../../../../../shared/components/core/formik-input/FormikInputComponent";
import Grid from "@mui/material/Grid";
import FormikSelectDropdownComponent
    from "../../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import React, {useCallback, useEffect} from "react";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../../store/reducers";
import CommonService from "../../../../../shared/services/common.service";
import commonService from "../../../../../shared/services/common.service";

interface BiomarkerBasicDetailsEditComponentProps {
    biomarkerBasicDetails?: any;
    onUpdateComplete: (biomarkerBasicDetails: any) => void;
    onEditCancel: () => void;
}

const BiomarkersBasicDetailsValidationSchema = Yup.object({
    name: Yup.string().required('Required'),
    // code: Yup.string().required('Required'),
    reportFormat: Yup.string().required('Required'),
    sampleType: Yup.string().required('Required'),
    sampleCollectionDeviceName: Yup.string().required('Required'),
    // description: Yup.string().nullable(),
});


const BiomarkerBasicDetailsEditComponent = (props: BiomarkerBasicDetailsEditComponentProps) => {
    const {biomarkerBasicDetails, onUpdateComplete, onEditCancel} = props;

    const {
        // sampleTypesList,
        // equipmentTypeList,
        sampleTypeWithCollectionDevices,
        reportTypeList
    } = useSelector((state: IRootReducerState) => state.staticData);

    const [biomarkerBasicDetailsInitialValues, setBiomarkerBasicDetailsInitialValues] = React.useState<any>(undefined);

    useEffect(() => {
        if (biomarkerBasicDetails) {
            setBiomarkerBasicDetailsInitialValues(biomarkerBasicDetails);
        }
    }, [biomarkerBasicDetails]);

    const onSubmit = useCallback((values: any, {setSubmitting, setFieldError}: any) => {
        setSubmitting(true);
        CommonService._biomarker.updateBiomarker(values, biomarkerBasicDetails?.id)
            .then((response: any) => {
                setSubmitting(false);
                onUpdateComplete(response?.data);
            })
            .catch((error: any) => {
                setSubmitting(false);
                CommonService._alert.showToast(error.error, "error");
            });
    }, [biomarkerBasicDetails, onUpdateComplete]);

    return (
        <div className={'biomarker-basic-details-edit-component'}>
            <Formik
                validationSchema={BiomarkersBasicDetailsValidationSchema}
                initialValues={biomarkerBasicDetailsInitialValues}
                validateOnChange={true}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}
                onSubmit={onSubmit}
            >
                {({isSubmitting, dirty, values, setFieldError, isValid, errors, setFieldValue, validateForm}) => {
                    return (
                        // eslint-disable-next-line no-script-url
                        <Form noValidate={true} action={'javascript:void'}
                              className={"biomarker-basic-details-add-holder"}>
                            <div className={"t-form-controls-wrapper pdd-top-5"}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        {/*<Field name={'code'}>*/}
                                        {/*    {*/}
                                        {/*        (field: FieldProps) => (*/}
                                        {/*            <FormikInputComponent*/}
                                        {/*                label={'Biomarker Code'}*/}
                                        {/*                fullWidth={true}*/}
                                        {/*                maxLength={4}*/}
                                        {/*                placeholder={'Enter Biomarker Code'}*/}
                                        {/*                type={"text"}*/}
                                        {/*                required={true}*/}
                                        {/*                formikField={field}*/}
                                        {/*            />*/}
                                        {/*        )}*/}
                                        {/*</Field>*/}
                                        <Field name={'name'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'Biomarker Name'}
                                                        fullWidth={true}
                                                        placeholder={'Enter Biomarker Name'}
                                                        type={"text"}
                                                        required={true}
                                                        formikField={field}
                                                    />
                                                )}
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'reportFormat'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikSelectDropdownComponent
                                                        label={'Report Type'}
                                                        options={reportTypeList}
                                                        placeholder={'Select Report Type'}
                                                        valueKey={'code'}
                                                        readOnly={true}
                                                        required={true}
                                                        getOptionLabel={(option) => (option.title) || ''}
                                                        formikField={field}
                                                        disabled
                                                    />
                                                )}
                                        </Field>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'sampleType'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikSelectDropdownComponent
                                                        label={'Sample Type'}
                                                        options={sampleTypeWithCollectionDevices}
                                                        placeholder={'Select Sample Type'}
                                                        valueKey={'sampleType'}
                                                        readOnly={true}
                                                        required={true}
                                                        getOptionLabel={(option) => (commonService.capitalizeFirstLetter(option.sampleType)) || ''}
                                                        formikField={field}
                                                        onUpdate={(value: any) => {
                                                            setFieldValue('sampleCollectionDeviceName', '');
                                                        }
                                                        }
                                                        disabled
                                                    />
                                                )}
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'sampleCollectionDeviceName'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikSelectDropdownComponent
                                                        label={'Sample Collection Device Name'}
                                                        placeholder={'Select Sample Collection Device Name'}
                                                        valueKey={'code'}
                                                        readOnly={true}
                                                        required={true}
                                                        getOptionLabel={(option) => (commonService.capitalizeOnlyFirstLetterOfEachWord(option.title)) || ''}
                                                        formikField={field}
                                                        options={commonService.extractCollectionDevicesFromSampleType(values?.sampleType, sampleTypeWithCollectionDevices)}
                                                        disabled
                                                    />
                                                )}
                                        </Field>
                                    </Grid>
                                </Grid>
                                {/*<Grid container spacing={2}>*/}
                                {/*    <Grid item xs={12} sm={12} md={12} xl={12}>*/}
                                {/*        <Field name={'description'}>*/}
                                {/*            {*/}
                                {/*                (field: FieldProps) => (*/}
                                {/*                    <FormikInputComponent*/}
                                {/*                        label={'Description (if any)'}*/}
                                {/*                        fullWidth={true}*/}
                                {/*                        placeholder={'Enter Description'}*/}
                                {/*                        type={"text"}*/}
                                {/*                        multiline={true}*/}
                                {/*                        rows={3}*/}
                                {/*                        required={false}*/}
                                {/*                        formikField={field}*/}
                                {/*                    />*/}
                                {/*                )}*/}
                                {/*        </Field>*/}
                                {/*    </Grid>*/}
                                {/*</Grid>*/}
                            </div>
                            <div className="form-action-section-edit">
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"secondary"}
                                    type={"button"}
                                    variant={"outlined"}
                                    disabled={isSubmitting}
                                    fullWidth={false}
                                    handleClick={() => {
                                        onEditCancel()
                                    }}
                                >
                                    Cancel
                                </ButtonComponent>
                                <ButtonComponent
                                    type="submit"
                                    color={"primary"}
                                    className={"width-25"}
                                    variant={"contained"}
                                    fullWidth={false}
                                    disabled={!(isValid && dirty)}
                                    isLoading={isSubmitting}
                                >
                                    Save
                                </ButtonComponent>
                            </div>
                        </Form>
                    )
                }
                }
            </Formik>
        </div>
    );

};

export default BiomarkerBasicDetailsEditComponent;
